export default function About() {
   return (
      <>
      <div className="mainabout">
        <div className="mainabout2">
        <h1>About Us</h1>
         <p>Welcome to Our Peradise. We would like to give you an overview of Restaurant. Our goal is to give you an honest look at Restaurantand provide you with the information you need to make a decision about whether this app is right for you.
            vandeervort was founded in 2019 by Dale D. Rubio and has become the leading review website for Restaurant. Provide complete, accurate, and up-to-date information about this product.
            We hope you enjoy Restaurant as much as we promote it. If you have any questions or comments, please do not hesitate to contact us.
            <br /> Sincerely, 
            <br />   
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Tawab Malikx</span> </p></div> 
      </div>
         
      </>
   );

}